import { render, staticRenderFns } from "./OmdAboutUs.vue?vue&type=template&id=3bfd9401&scoped=true"
var script = {}
import style0 from "./OmdAboutUs.vue?vue&type=style&index=0&id=3bfd9401&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfd9401",
  null
  
)

export default component.exports